// extracted by mini-css-extract-plugin
export default {"driveLink":"DriveLink_driveLink__7K0Hf"};